<template>
  <section class="image-carousel">
      <div class="image-carousel__owl-carousel owl-carousel">
        <div>
          <img src="../assets/carousel/image-1.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-2.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-3.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-4.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-5.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-6.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-7.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-8.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-9.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-10.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-11.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-12.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-13.jpeg" alt=""/>
        </div>
        <div>
          <img src="../assets/carousel/image-14.jpeg" alt=""/>
        </div>
      </div>
  </section>
</template>

<script>
const $ = require( 'jquery' );

export default {
  name: 'ImageCarousel',
  data () {
    return {
    }
  },
  mounted() {
    $(document).ready(function(){
      $('.owl-carousel').owlCarousel({
          margin: 10,
          loop: true,
          autoWidth: true,
          items: 4,
          dots: false,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          smartSpeed: 1000,
      });
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/ImageCarousel.scss";
</style>
